import { Cart } from '../entities/cart/cart.entity';
import { CartSplitPolicy, OrderDraft, OrderType, SplitConfiguration } from '../models/order/order-split.model';

export class CartPartitioner {
  constructor(private readonly policies: CartSplitPolicy[]) {
  }

  partition(cart: Cart, config: SplitConfiguration): OrderDraft[] {
    const policy = this.policies.find((p) => p.supports(config));

    if (!policy) {
      return [
        {
          type: OrderType.SALE,
          items: cart.toDTOs(),
        },
      ];
    }

    return policy.partition(cart, config);
  }
}
